import { requestGet, requestFormPost } from '@/common/request';

export const queryRoomMembers = async (query) => requestGet('/roomMember/queryRoomMembers', query);
export const addRoomMembers = async (query) => requestGet('/roomMember/addMembers', query);
export const transferLeader = async (query) => requestGet('/roomMember/transferLeader', query);
export const removeMember = async (query) => requestGet('/roomMember/removeMember', query);
export const checkMembers = async (data) => requestGet('/roomMember/checkMembers', data);
export const getRoomPoolDetail = async (query) => requestGet('/room/poolHeader', query);
export const getRoomDetail = async (query) => requestGet('/room/getDetailByRoomId', query);
export const getIsMember = async (query) => requestGet('/roomMember/isMember', query);
export const getIsRelated = async (query) => requestGet('/room/hasRelation', query);
export const getAreaDetail = async (data) => requestFormPost('/generic/newSeckill/openness/area/detail', { ...data });
